module.exports = __webpack_public_path__ + "static/img/banner-go-download.a262ec5.webp";